import { useNavigate } from 'react-router-dom';

import { usePagamentos as usePagamentosDoNucleo } from '@maestra/core/telas/dinheiro/usePagamentos';

// O HISTÓRICO DE PAGAMENTOS (o resumo e as linhas) mora no núcleo desde 31/10/2026, e o app mostra
// o mesmo (docs/PLANO-APP-NATIVO.md).
export type { DadosDosPagamentos } from '@maestra/core/telas/dinheiro/usePagamentos';

export const usePagamentos = () => {
  const navigate = useNavigate();
  return usePagamentosDoNucleo({ ir: navigate });
};
